// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Nv_J","inner":"Footer_inner__zZtED"};